import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

import { navigation } from 'app/navigation/navigation';
import { AuthService } from 'app/authentication/auth.service';
import { Router, NavigationEnd, Event } from '@angular/router';
import { QuickPanelSubjectService } from '../quick-panel/quick-panel-subject.service';
import { fuseAnimations } from '@fuse/animations';
import { MatDialog } from '@angular/material';
import { DiaryModalComponent } from 'app/modules-core/diary/components/diary-modal/diary-modal.component';
import { ContractService } from 'app/modules-core/principal/contract/contract.service';
import { SnackbarService } from 'app/modules-core/utility/snackbar.service';
import { MigrateService } from 'app/modules-core/common/migrate/migrate.service';
import { LOCAL_STORAGE_APPLICATION_LIST } from 'app/storage.constants';
import { UserManualService } from 'app/modules-core/principal/user-manual/user-manual.service';
import { AttachmentService } from 'app/modules-core/common/attachment/attachment.service';

@Component({
  selector: 'toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})

export class ToolbarComponent implements OnInit, OnDestroy {
  @ViewChild('contractListModal') contractListModal;


  horizontalNavbar: boolean;
  rightNavbar: boolean;
  hiddenNavbar: boolean;
  languages: any;
  navigation: any;
  selectedLanguage: any;
  userStatusOptions: any[];
  countNotification = 0;
  currentUser = <any>{};
  heading = null;
  showOrderButton = false;
  orderDate = new Date;

  scanedItem: string = null
  appList: any = [];


  modalRef: any = null;
  btnDisabled = false;

  contractList: any[] = [];
  attachmentList: any[] = [];
  currentRoute = null;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   * @param {FuseSidebarService} _fuseSidebarService
   * @param {TranslateService} _translateService
   */
  constructor(
    private _fuseConfigService: FuseConfigService,
    private _migrationService: MigrateService,
    private _fuseSidebarService: FuseSidebarService,
    private _translateService: TranslateService,
    private auth: AuthService,
    private router: Router,
    public dialog: MatDialog,
    public _contractService: ContractService,
    public _migrateService: MigrateService,
    private _quickPanelSubjectService: QuickPanelSubjectService,
    private snackBar: SnackbarService,
    private _userManualService: UserManualService,
    private _attachmentService: AttachmentService

  ) {
    // Set the defaults
    this.userStatusOptions = [
      {
        'title': 'Online',
        'icon': 'icon-checkbox-marked-circle',
        'color': '#4CAF50'
      },
      {
        'title': 'Away',
        'icon': 'icon-clock',
        'color': '#FFC107'
      },
      {
        'title': 'Do not Disturb',
        'icon': 'icon-minus-circle',
        'color': '#F44336'
      },
      {
        'title': 'Invisible',
        'icon': 'icon-checkbox-blank-circle-outline',
        'color': '#BDBDBD'
      },
      {
        'title': 'Offline',
        'icon': 'icon-checkbox-blank-circle-outline',
        'color': '#616161'
      }
    ];

    this.languages = [
      {
        id: 'en',
        title: 'English',
        flag: 'us'
      },
      {
        id: 'tr',
        title: 'Turkish',
        flag: 'tr'
      }
    ];

    this.navigation = navigation;

    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to the config changes
    this._fuseConfigService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((settings) => {
        this.horizontalNavbar = settings.layout.navbar.position === 'top';
        this.rightNavbar = settings.layout.navbar.position === 'right';
        this.hiddenNavbar = settings.layout.navbar.hidden === true;
      });

    // Set the selected language from default languages
    this.selectedLanguage = _.find(this.languages, { 'id': this._translateService.currentLang });

    this.currentUser = this.auth.getCurrentUser();
    this._quickPanelSubjectService.notification$.subscribe(data => {
      this.countNotification = data;
    });

    this._quickPanelSubjectService.heading$.subscribe(data => {
      this.heading = data;
    });

    this._quickPanelSubjectService.applicationListData$.subscribe(data => {
      this.appList = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_APPLICATION_LIST))
    });

    this.router.events.subscribe(() => {
      this.currentRoute = this.router.url; // Get the current URL as a string
    });
  }

  beep() {
    var snd = new Audio("data:audio/wav;base64,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");
    snd.play();
  }



  getPreviousMonthOrder() {
    this._quickPanelSubjectService.previousMonthData.next(true);
  }

  getNextMonthOrder() {
    this._quickPanelSubjectService.nextMonthData.next(true);
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle sidebar open
   *
   * @param key
   */
  toggleSidebarOpen(key): void {
    this._fuseSidebarService.getSidebar(key).toggleOpen();
  }

  /**
   * Search
   *
   * @param value
   */
  search(value): void {
    // Do your search here...
    console.log(value);
  }

  /**
   * Set the language
   *
   * @param lang
   */
  setLanguage(lang): void {
    // Set the selected language for the toolbar
    this.selectedLanguage = lang;

    // Use the selected language for translations
    this._translateService.use(lang.id);
  }
  profile() {
    this.router.navigateByUrl('/profile');
  }

  logout() {
    this.auth.logout();
  }

  goToSettingsPage() {
    this.router.navigateByUrl('/settings');
  }

  goToDiaryPage() {
    const basicModal = this.dialog.open(DiaryModalComponent, {
      width: '70%'
    });

    basicModal.afterClosed().subscribe(result => {
    });
  }



  goToPath() {
    if (this.scanedItem) {
      let params = { text: this.scanedItem }
      this._contractService.getContractsLight(params).subscribe(res => {


        if (_.size(res) > 1) {
          this.contractList = res;
          this.openContractModal();
        } else if (_.size(res) == 1) {
          let item = _.head(res);
          this.onContract(item);
        } else {
          this.snackBar.open(`No item found!`, 'Close');
        }
      });
    }
    this.scanedItem = null;
  }

  goBack() {
    this.router.navigateByUrl(_.get(this.heading, 'backlink'));
  }


  openContractModal() {
    this.modalRef = this.dialog.open(this.contractListModal, {
      minWidth: "500px",
    });
  }

  onContract(item) {
    let id = _.get(item, 'id', null);
    if (id) {
      if (_.get(item, 'statusName') == 'in_execution') {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
          this.router.navigate([`inexecution-contracts/${id}/detail`]));
        // this.router.navigateByUrl(`inexecution-contracts/${id}/detail`);
      } else if (_.get(item, 'statusName') == 'planned') {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
          this.router.navigate([`planned-contracts/${id}/detail`]));
        // this.router.navigateByUrl(`planned-contracts/${id}/detail`);
      } else if (_.get(item, 'statusName') == 'closed') {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
          this.router.navigate([`closed-contracts/${id}/detail`]));
        // this.router.navigateByUrl(`planned-contracts/${id}/detail`);
      }
      else {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
          this.router.navigate([`upcoming-contracts/${id}/detail`]));
        // this.router.navigateByUrl(`upcoming-contracts/${id}/detail`);
      }
    }

    this.modalRef && this.modalRef.close();
  }

  migrateDB() {
    this.btnDisabled = true
    this._migrationService.run().subscribe(res => {
      this.snackBar.open(`No item found!`, 'Close');
      this.btnDisabled = false
    }, error => {
      this.btnDisabled = false
    });
  }

  goToApp(data) {
      window.open(`${data.url}login-from-other-application?accessToken=${this.currentUser.accessToken}&email=${this.currentUser.email}&fromAppName=ccmis_application`, '_blank');
  }

  openDocumentModal(templateRef: TemplateRef<any>) {
    this._userManualService.getAll({ pageUrl: this.transformRoute(this.currentRoute) }).subscribe(res => {
      if (res.length) {
        this._attachmentService.getAll({ entitytype: res[0].entityName, entityid: res[0].id }).subscribe(att => {
          this.attachmentList = att;
          this.modalRef = this.dialog.open(templateRef, {
            minWidth: "400px",
            disableClose: true,
          });
        })
      }
      else {
        this.snackBar.open(`No user manual found for this page!`, 'Close');
      }
    });
  }


  transformRoute(route: string): string {
    // Step 1: Remove query parameters
    const pathWithoutQuery = route.split('?')[0];

    // Step 2: Remove the leading slash
    const pathWithoutFirstSlash = pathWithoutQuery.replace(/^\//, '');

    // Step 3: Replace all numbers with 1, except the first numeric segment
    return pathWithoutFirstSlash.replace(/\/\d+/g, (match, offset) => {
      // If it's the first numeric segment, keep it unchanged
      if (offset === 0) {
        return match;
      }
      // Replace other numeric segments with '/1'
      return '/1';
    });
  }
}
